let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("kFOec"), load("16ht2"), load("70aiP"), load("ePOyH"), load("cS7dz")]).then(() => parcelRequire('ec8HN'));